
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
// import Preloader from '../Preloader/Preloader';  
import axios from 'axios';

const StudentLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [userId, setUserId] = useState('');  // Changed to camelCase
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [identifier, setIdentifier] = useState('');

  const navigate = useNavigate();

  // Toggle password visibility
  const handleShowPasswordChange = () => {
    setShowPassword(!showPassword);
  };

  // Handle login form submission
  const handleLogin = async (e) => {
    e.preventDefault();
  
    if (!identifier.trim() || !password.trim()) {
      setError('Identifier and password are required.');
      return;
    }
  
    let identifierType = null;
  
    if (/^\d{12}$/.test(identifier)) {
      identifierType = 'aadhaar';
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier)) {
      identifierType = 'email';
    } else {
      identifierType = 'userId';
    }
  
    setLoading(true);
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/student/studentlogin`, {
        identifier,
        identifierType,
        password,
      });
  
      if (response.data.message === 'Login successful') {
        const { id, username, role, userId } = response.data.user;
        localStorage.setItem('username', username);
        localStorage.setItem('userRole', role);
        localStorage.setItem('UserId', userId);  // storing it as UserId in localStorage is fine
        localStorage.setItem('isStudentLogin', 'true');
        // console.log(localStorage.getItem('UserId'));
        navigate('/profile');
        

        // const { id, username, role, UserId } = response.data.user;

        // console.log(response.data.user)
   
        // localStorage.setItem('username', username);
        // localStorage.setItem('userRole', role);
        // localStorage.setItem('UserId', UserId);
        // localStorage.setItem('isStudentLogin', 'true');
        // console.log(localStorage.getItem('UserId'))
        // navigate('/profile');
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      console.error('Error during login:', error);
      setError(error.response?.data?.message || 'An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };
    return (
    <div>
      {/* {loading && <Preloader />} */}
      <div className="page-wrapper">
        <Header />
        

        <section className="login-page section-space">
          <div className="container">
            <div className="row gutter-y-40">
              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-right" data-aos-duration="1000">
                <div className="login-page__image"
                  
     style={{
    position: 'relative',
    width: '100%',
    maxWidth: '600px',
    height: '450px',
    overflow: 'hidden',
    paddingRight: '10px'
  }}
>
  {/* Heading Overlay */}
  <h2
      style={{
      position: 'absolute',
      top: '10px',
      left: '20px',
      margin: 0,
      padding: '6px 12px',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      color: '#fff',
      fontSize: '24px',
      fontWeight: 'bold',
      borderRadius: '5px',
      zIndex: 2
    }}
  >
    2023–2024 Winners
  </h2>

  {/* Desktop Images */}
  <img
      src="assets/images/login/schlimg.jpg"
      alt="login"
      className="desktop-img"
      style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      animation: 'slideFade 9s infinite',
      animationDelay: '0s',
      opacity: '0',
      animationFillMode: 'forwards'
    }}
  />
  <img
      src="assets/images/login/schlimg1.jpg"
      alt="login1"
      className="desktop-img"
      style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      animation: 'slideFade 9s infinite',
      animationDelay: '3s',
      opacity: '0',
      animationFillMode: 'forwards'
    }}
  />
  <img
      src="assets/images/login/schlimg2.jpg"
      alt="login2"
      className="desktop-img"
      style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      animation: 'slideFade 9s infinite',
      animationDelay: '6s',
      opacity: '0',
      animationFillMode: 'forwards'
    }}
  />

  {/* Mobile Image */}
  <img
      src="assets/images/login/schlimg.jpg"
      alt="login-mobile"
      className="mobile-img"
      style={{
      display: 'none',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      position: 'absolute'
    }}
  />

  {/* Styles */}
  <style>
    {`
      @keyframes slideFade {
        0% { opacity: 0; }
        10% { opacity: 1; }
        30% { opacity: 1; }
        40% { opacity: 0; }
        100% { opacity: 0; }
      }

      @media (max-width: 768px) {
        .desktop-img {
          display: none !important;
        }

        .mobile-img {
          display: block !important;
        }
      }
    `}
  </style>
</div>

</div>
             
            

              <div className="col-lg-6 wow fadeInUp" data-aos="fade-up-left" data-aos-duration="1000">
                <div className="login-page__form">
                  <span className="login-page__form__top-title" style={{ backgroundColor: '#ffd767' }}>Log in</span>
                  <h2 className="login-page__form__title">Welcome to our community</h2>

                  {error && <p className="error-message" style={{ color: 'red' }}>{error}</p>}

                  <form className="login-page__form__box form-one" onSubmit={handleLogin}>
                    <div className="login-page__form__input-box form-one__control">
                      <input
  className="form-one__control__input"
  type="text"
  placeholder="Aadhaar / User ID / Email"
  value={identifier}
  onChange={(e) => setIdentifier(e.target.value)}
  required
/>

                    </div>
                    <div className="login-page__form__input-box form-one__control">
                      <input
                        className="form-one__control__input"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="login-page__form__input-box login-page__form__checkbox-forgot">
                      <div className="login-page__form__checkbox">
                        <input
                          type="checkbox"
                          id="save_login"
                          checked={showPassword}
                          onChange={handleShowPasswordChange}
                        />
                        <label htmlFor="save_login">Show Password</label>
                      </div>
                      <Link to="/forgot-password" className="login-page__form__forgot">Forgot your password?</Link>
                    </div>

                    <div className="login-page__form__input-box">
                      <button type="submit" className="cleenhearts-btn" disabled={loading}>
                        <span className="cleenhearts-btn__icon-box">
                          <span className="cleenhearts-btn__icon-box__inner"><span className="icon-duble-arrow"></span></span>
                        </span>
                        <span className="cleenhearts-btn__text">{loading ? 'Logging in...' : 'Log in'}</span>
                      </button>
                     

                    <div style={{
  // backgroundColor: '#f9f9f9',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  textAlign: 'center',
  marginTop: '30px'
}}>
  <h2 style={{
    marginBottom: '10px',
    color: '#333',
    fontSize: '18px'
  }}>
    Don’t have an account?
  </h2>
  <Link
    to="/signin"
    style={{
      color: 'inherit',
     backgroundColor: 'var(--cleenhearts-secondary)',

      padding: '10px 20px',
      borderRadius: '6px',
      textDecoration: 'none',
      fontWeight: 'bold',
      display: 'inline-block',
      transition: '0.3s',
    }}
    // onMouseOver={e => e.currentTarget.style.backgroundColor = '#0056b3'}
    // onMouseOut={e => e.currentTarget.style.backgroundColor = '#007BFF'}
  >
    Register Here
  </Link>
</div>


                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default StudentLogin;
